import {
	UndefinedInitialDataOptions,
	queryOptions
} from '@tanstack/react-query'

import { LikeTypes, likeKeys } from '../config/likeQueryKeys.ts'
import { likeIdsQuery } from '../query/likeIdsQuery.ts'

export const likeIdsOptions = (
	otherParams: Omit<
		UndefinedInitialDataOptions<LikeTypes['ids']>,
		'queryKey' | 'queryFn'
	> = {}
) => {
	return queryOptions<LikeTypes['ids']>({
		queryKey: likeKeys.ids(),
		queryFn: ({ signal }) => likeIdsQuery(signal),
		initialData: {},
		initialDataUpdatedAt: 0,
		...otherParams
	})
}
